import React, { useMemo, useState } from "react";
import * as moment from "moment";
import { Field, Formik } from "formik";
import { CTA, SocialSecurityInputField } from "@coverme/forms";
import { isNullOrWhitespace, isNotNullOrWhitespace } from "../../services/stringService";
import "./MyCasesFilters.scss";
import * as formsService from "../../services/formsService";
import { PatientFilters } from "./PatientFilters";
import { ProgramFilters } from "./ProgramFilters";
import { validationSchema } from "./validationSchema";
import { SingleFilter } from "./SingleFilter";
import * as Yup from "yup";
import Axios from "axios";
import { toast } from "react-toastify";
import { PhoneInputField } from "@coverme/forms";
import { Link } from "react-router-dom";
import { some } from "lodash-es";
import {
    getMatchingPerson,
    getMatchingPersonBySsn,
} from "../../containers/InterviewWizard/services/personMatchService";
import { cloneEncounter } from "../../actions/interviewActions";
import { isCallCenterUser } from "../../services/userService";
import { PersonMatchModal } from "../PersonMatchModal/PersonMatchModal";
import { Icon } from "@coverme/icons";

const EncounterStatusFilter = ({ name, value, onChange, disabled }) => {
    return (
        <>
            <p className="my-cases-filters__status">Encounter Status</p>
            <SingleFilter filterStatus="New" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="In Progress" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Pending" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Pending Decision" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Complete" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Closed" value={value} onChange={onChange} disabled={disabled} />
        </>
    );
};

export const MyCasesFilters = ({
    cases,
    submitFilter,
    history,
    users,
    customers,
    programs,
    exportEncounters,
    setIsProgramForm,
    customerPrograms,
    customerId,
    customerFeatures,
    setSimplePersonDemographics,
    user,
    lookups,
    showStartNewCase = true,
}) => {
    const [isPatientFilterVisible, setIsPatientFilterVisible] = useState(true);
    const [programFilterButtonStyle, setProgramFilterButtonStyle] = useState("grey-dark-alt");
    const [patientFilterButtonStyle, setPatientFilterButtonStyle] = useState("grey-dark");
    const [showMobileTextField, setShowMobileTextField] = useState(false);
    const [showSearchBySsn, setShowSearchBySsn] = useState(false);

    const isTextLinkFeatureEnabled = some(customerFeatures, x => x === "TextFormEntry");
    const isTagsEnabled = some(customerFeatures, x => x === "Tags");

    const uniqueProgramsList = useMemo(() => {
        if (programs !== null && programs !== undefined) {
            return [...new Set(programs?.map(x => x.label))];
        }
    }, [programs]);

    const faPrograms = useMemo(() => {
        if (customerPrograms == null) return null;
        return customerPrograms?.filter(
            x => x?.programType?.name === "Customer" && x.assistanceCategory.name !== "Cash Discount"
        );
    }, [customerPrograms]);

    const onFormReset = (formData, resetForm) => {
        let multiValRemove = document.getElementsByClassName("css-1alnv5e multi-select__multi-value__remove");
        let removeLength = multiValRemove.length;

        for (let i = 0; i < removeLength; i++) {
            setTimeout(function() {
                multiValRemove[0].click();
            }, 100);
        }
    };

    const extractFilter = formData => {
        const dataToSend = { ...formData };
        if (isNullOrWhitespace(dataToSend.encounterStartDate)) {
            delete dataToSend.encounterStartDate;
        } else {
            const validDate = moment.utc(dataToSend.encounterStartDate, "MM/DD/YYYY", true);
            if (validDate.isValid()) {
                dataToSend.encounterStartDate = validDate.toISOString();
                dataToSend.earliestEncounterDate = validDate.endOf("day").toISOString();
            } else {
                delete dataToSend.encounterStartDate;
            }
        }

        if (isNullOrWhitespace(dataToSend.encounterEndDate)) {
            delete dataToSend.encounterEndDate;
        } else {
            const validDate = moment.utc(dataToSend.encounterEndDate, "MM/DD/YYYY", true);
            if (validDate.isValid()) {
                dataToSend.encounterEndDate = validDate.toISOString();
                dataToSend.latestEncounterDate = validDate.endOf("day").toISOString();
            } else {
                delete dataToSend.encounterEndDate;
            }
        }

        dataToSend.includeDependentUsers = true;
        dataToSend.personCriteria = {
            ...dataToSend.personCriteria,
            isPatient: true,
        };

        if (isNullOrWhitespace(dataToSend.lastFourOfSsn)) {
            delete dataToSend.lastFourOfSsn;
        } else {
            dataToSend.personCriteria = {
                ...dataToSend.personCriteria,
                lastFourOfSsn: dataToSend.lastFourOfSsn,
            };
        }

        if (isNullOrWhitespace(dataToSend.dob)) {
            delete dataToSend.dob;
        } else {
            const validDate = moment.utc(dataToSend.dob, "MM/DD/YYYY", true);
            if (validDate.isValid()) {
                dataToSend.dob = validDate.toISOString();
                dataToSend.personCriteria = {
                    ...dataToSend.personCriteria,
                    latestDateOfBirth: validDate.endOf("day").toISOString(),
                };
            } else {
                delete dataToSend.dob;
            }
        }

        if (isNullOrWhitespace(dataToSend.phoneNumber)) {
            delete dataToSend.phoneNumber;
        } else {
            dataToSend.personCriteria = {
                ...dataToSend.personCriteria,
                phone: dataToSend.phoneNumber,
            };
        }

        if (dataToSend.customers == null || dataToSend.customers.length === 0) {
            dataToSend.includeDependentCustomers = true;
        }

        if (isNotNullOrWhitespace(dataToSend.filterUCI)) {
            dataToSend.uniqueCaseIds = [dataToSend.filterUCI];
            delete dataToSend.filterUCI;
        }

        if (formData?.filterEncounter?.length > 0) {
            dataToSend.EncounterStatuses = ["Complete"];
        }

        if (formData?.filterProgram?.length > 0) {
            dataToSend.ProgramStatuses = ["Recommended"];
        }

        if (dataToSend.programs?.includes("All Financial Assistance Programs")) {
            const allFinancialAssistancePrograms = faPrograms?.map(x => x.programName);
            dataToSend.programs = allFinancialAssistancePrograms?.join(",");
        }

        if (dataToSend.programs?.includes("All HPE Programs")) {
            const allHPEPrograms = programs
                .filter(x => x.label.includes("HPE") && !x.label.includes("All HPE Programs"))
                .map(x => x.label);
            dataToSend.programs = allHPEPrograms.join(",");
        }

        return dataToSend;
    };

    const onFormSubmit = formData => {
        const dataToSend = extractFilter(formData);
        submitFilter(dataToSend);
    };

    const onExportClicked = formData => {
        const dataToSend = extractFilter(formData);
        exportEncounters(dataToSend);
    };

    function tabChanged(isProgramTab) {
        setIsProgramForm(isProgramTab);
    }

    const initialValues = { EncounterStatuses: [], ProgramStatuses: [] };
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onFormSubmit}
            onReset={onFormReset}
            validationSchema={validationSchema}
            render={props => {
                const {
                    setFieldValue,
                    setFieldTouched,
                    handleReset,
                    handleSubmit,
                    errors,
                    touched,
                    values,
                    submitForm,
                } = props;
                const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                const getErrors = formsService.getErrors.bind(this, errors);
                return (
                    <div>
                        <form id="myCasesFiltersForm">
                            <div className="my-cases-filters">
                                <div className="my-cases-filters__bottom-container">
                                    <div className="my-cases-filters__top">
                                        <div className="filters-tabs">
                                            <CTA
                                                size={"medium"}
                                                ctaType={"button"}
                                                styleType={patientFilterButtonStyle}
                                                click={() => {
                                                    setIsPatientFilterVisible(true);
                                                    setPatientFilterButtonStyle("grey-dark");
                                                    setProgramFilterButtonStyle("grey-dark-alt");
                                                    tabChanged(false);
                                                    handleReset();
                                                    handleSubmit();
                                                }}
                                            >
                                                {isTagsEnabled ? "CoverMe Complete" : "Patient"}
                                            </CTA>
                                            <CTA
                                                size={"medium"}
                                                ctaType={"button"}
                                                styleType={programFilterButtonStyle}
                                                click={() => {
                                                    setIsPatientFilterVisible(false);
                                                    setProgramFilterButtonStyle("grey-dark");
                                                    setPatientFilterButtonStyle("grey-dark-alt");
                                                    tabChanged(true);
                                                    handleReset();
                                                    handleSubmit();
                                                }}
                                            >
                                                {"Programs"}
                                            </CTA>
                                        </div>
                                        <div className="banner-buttons">
                                            <div className="nav-buttons">
                                                {!showMobileTextField && isTextLinkFeatureEnabled && (
                                                    <CTA
                                                        disabled={!showStartNewCase}
                                                        size={"medium"}
                                                        ctaType={"button"}
                                                        styleType={"blue"}
                                                        click={() => {
                                                            setShowMobileTextField(true);
                                                        }}
                                                    >
                                                        Mobile
                                                    </CTA>
                                                )}
                                                {showMobileTextField && isTextLinkFeatureEnabled && (
                                                    <TextLinkFormNew
                                                        customerId={customerId}
                                                        setShowMobileTextField={setShowMobileTextField}
                                                    />
                                                )}
                                            </div>
                                            <div className="nav-buttons">
                                                {!showSearchBySsn && (
                                                    <CTA
                                                        disabled={false}
                                                        size={"medium"}
                                                        ctaType={"button"}
                                                        styleType={"blue"}
                                                        click={() => {
                                                            setShowSearchBySsn(true);
                                                        }}
                                                    >
                                                        Find
                                                    </CTA>
                                                )}
                                                {showSearchBySsn && (
                                                    <SearchBySSN
                                                        setSimplePersonDemographics={setSimplePersonDemographics}
                                                        user={user}
                                                        history={history}
                                                        customerId={customerId}
                                                        setShowSearchBySsn={setShowSearchBySsn}
                                                    />
                                                )}
                                            </div>
                                            <div className="nav-buttons">
                                                <Link to="/interview/new/person" className="link">
                                                    <CTA
                                                        disabled={!showStartNewCase}
                                                        size={"medium"}
                                                        ctaType={"button"}
                                                        styleType={"blue"}
                                                    >
                                                        New
                                                    </CTA>
                                                </Link>
                                            </div>
                                        </div>{" "}
                                    </div>

                                    {isPatientFilterVisible === true && (
                                        <PatientFilters
                                            EncounterStatusFilter={EncounterStatusFilter}
                                            values={values}
                                            isPatientFilterVisible={isPatientFilterVisible}
                                            getErrors={getErrors}
                                            getValidationState={getValidationState}
                                            setFieldValue={setFieldValue}
                                            setTimeout={setTimeout}
                                            customers={customers}
                                            setFieldTouched={setFieldTouched}
                                            users={users}
                                            uniqueProgramsList={uniqueProgramsList}
                                            onExportClicked={onExportClicked}
                                            validationSchema={validationSchema}
                                            handleReset={handleReset}
                                            handleSubmit={onFormSubmit}
                                            submitForm={submitForm}
                                            isTagsEnabled={isTagsEnabled}
                                            lookups={lookups}
                                        />
                                    )}
                                    {isPatientFilterVisible === false && (
                                        <ProgramFilters
                                            values={values}
                                            isPatientFilterVisible={isPatientFilterVisible}
                                            getErrors={getErrors}
                                            getValidationState={getValidationState}
                                            setFieldValue={setFieldValue}
                                            setTimeout={setTimeout}
                                            customers={customers}
                                            setFieldTouched={setFieldTouched}
                                            programs={programs}
                                            users={users}
                                            validationSchema={validationSchema}
                                            handleReset={handleReset}
                                            handleSubmit={handleSubmit}
                                            submitForm={submitForm}
                                            onExportClicked={onExportClicked}
                                        />
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                );
            }}
        />
    );
};

export const TextLinkFormNew = ({ customerId, setShowMobileTextField }) => {
    const initialValues = {
        phone: "",
    };

    const validationSchema = Yup.object().shape({
        phone: Yup.string()
            .required("Required")
            .min(10, "Invalid Phone Number")
            .max(10, "Invalid Phone Number"),
    });
    return (
        <div className="">
            <Formik
                initialValues={initialValues}
                onSubmit={(formData, { resetForm }) => {
                    return Axios.post(
                        `/api/customer/${customerId}/encounters/ocr`,
                        JSON.stringify(formData.phone)
                    ).then(() => {
                        resetForm();
                        toast.info("Text message sent.");
                        setShowMobileTextField(false);
                    });
                }}
                validationSchema={validationSchema}
                render={({ setFieldValue, handleSubmit, setFieldTouched, resetForm, errors, touched, ...props }) => {
                    const { values } = props;
                    const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                    return (
                        <form className="textLinkForm">
                            <div className="joint-input-button">
                                <Field
                                    name="phone"
                                    render={({ field }) => (
                                        <PhoneInputField
                                            {...field}
                                            id="text-link-PhoneInputField"
                                            value={field.value}
                                            changeEvent={e => {
                                                setFieldValue(field.name, e);
                                            }}
                                            disabled={false}
                                            validState={getValidationState(field)}
                                            errorMessage={errors.phone}
                                            autoFocus
                                            onBlur={() => {
                                                if (field.value === "" || field.value == null) {
                                                    setShowMobileTextField(false);
                                                }
                                            }}
                                        />
                                    )}
                                />
                                <CTA
                                    disabled={false}
                                    size={"small"}
                                    ctaType={"submit"}
                                    styleType={"blue"}
                                    click={handleSubmit}
                                >
                                    <div className="mobileVerify__icon"> &#x2709;</div>
                                </CTA>
                            </div>
                        </form>
                    );
                }}
            />
        </div>
    );
};

export const SearchBySSN = ({ setSimplePersonDemographics, user, history, customerId, setShowSearchBySsn }) => {
    const initialValues = {
        socialSecurityNumber: "",
    };
    const [matchingPersons, setMatchingPersons] = useState([]);
    const [isModalShown, setIsModalShown] = useState(false);
    const [formData, setFormData] = useState(null);

    const validationSchema = Yup.object().shape({
        socialSecurityNumber: Yup.string()
            .required("Required")
            .min(9, "Invalid SSN")
            .max(9, "Invalid SSN"),
    });

    return (
        <>
            <PersonMatchModal
                isShown={isModalShown}
                persons={matchingPersons}
                history={history}
                user={user}
                onClose={() => {
                    setIsModalShown(false);
                }}
                onPersonVerify={(shouldStartNow, selectedPersonId) => {
                    Axios.get(`/api/customer/${customerId}/person/${selectedPersonId}/encounter/latest`).then(
                        result => {
                            const encounterId = result.data;
                            return cloneEncounter(encounterId).then(newEncounterId => {
                                if (shouldStartNow) {
                                    return history.push(`/interview/${newEncounterId}/entry`);
                                } else {
                                    if (isCallCenterUser(user)) {
                                        toast.success(
                                            "A new case was created with person matching. Please continue the rest of the interview at the hospital"
                                        );
                                        return history.push(`/customerselection`);
                                    }
                                    setIsModalShown(false);
                                    return history.push("/");
                                }
                            });
                        }
                    );
                }}
                onNoMatchFound={() => {
                    formData.dob = null;
                    formData.serviceStartDate = null;
                    formData.serviceEndDate = null;
                    setSimplePersonDemographics(formData);
                    history.push({
                        pathname: "/interview/new/person",
                        appState: {
                            ssn: formData.socialSecurityNumber,
                        },
                    });
                }}
            />
            <Formik
                onSubmit={(formData, { resetForm }) => {
                    getMatchingPersonBySsn(customerId, formData).then(result => {
                        setMatchingPersons(result.data);
                        setIsModalShown(true);
                        setFormData(formData);
                        resetForm();
                    });
                }}
                initialValues={initialValues}
                validationSchema={validationSchema}
                render={props => {
                    const { setFieldValue, setFieldTouched, resetForm, handleSubmit, errors, touched, values } = props;
                    const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                    return (
                        <form className="textLinkForm">
                            <div className="input-field">
                                <Field
                                    name="socialSecurityNumber"
                                    render={({ field }) => (
                                        <SocialSecurityInputField
                                            {...field}
                                            id="new_case_ssn"
                                            value={field.value}
                                            changeEvent={e => {
                                                setFieldValue(field.name, e.substring(0, 9));
                                            }}
                                            validState={getValidationState(field)}
                                            errorMessage={errors.phone}
                                            autoFocus
                                            onBlur={() => {
                                                if (field.value === "" || field.value == null) {
                                                    setShowSearchBySsn(false);
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="submit-button">
                                <CTA size={"small"} ctaType={"submit"} styleType={"blue"} click={handleSubmit}>
                                    <div className="search__icon">&#x1F50E;&#xFE0E;</div>
                                </CTA>
                            </div>
                        </form>
                    );
                }}
            />
        </>
    );
};
